import type { Dispatch, SetStateAction } from 'react';
import { LanguageOption } from 'src/utils/languages';
import { DEFAULT_ENGLISH_LANGUAGE } from '../constants';
import { FormCreationMode } from '../types';

export function resolveDefaultEnglishIfEmpty(
  current: LanguageOption[],
): LanguageOption[] {
  return current.length > 0 ? current : [DEFAULT_ENGLISH_LANGUAGE];
}

export function setDefaultEnglishIfEmpty(
  setSelectedLanguages: Dispatch<SetStateAction<LanguageOption[]>>,
) {
  setSelectedLanguages(resolveDefaultEnglishIfEmpty);
}

export const handleAddDefaultLanguage = async (
  setMode: (mode: FormCreationMode) => void,
  setSelectedLanguages: (languages: LanguageOption[]) => void,
) => {
  setMode('loading');
  setSelectedLanguages([DEFAULT_ENGLISH_LANGUAGE]);
  await new Promise((resolve) => setTimeout(resolve, 1500));
  setMode('content');
};

export const handleAddLanguage = async (
  language: LanguageOption,
  mode: FormCreationMode,
  selectedLanguages: LanguageOption[],
  setMode: (mode: FormCreationMode) => void,
  setSelectedLanguages: (languages: LanguageOption[]) => void,
) => {
  if (selectedLanguages.find((lang) => lang.value === language.value)) return;

  if (mode === 'initial') {
    setMode('loading');
    setSelectedLanguages([DEFAULT_ENGLISH_LANGUAGE]);
    await new Promise((resolve) => setTimeout(resolve, 1500));
    setMode('content');
    return;
  }

  const isFirstLanguage = selectedLanguages.length === 0;
  setSelectedLanguages([
    ...selectedLanguages,
    { ...language, isDefault: isFirstLanguage },
  ]);
};

export const handleRemoveLanguage = (
  languageValue: string,
  selectedLanguages: LanguageOption[],
  setSelectedLanguages: (languages: LanguageOption[]) => void,
) => {
  const languageToRemove = selectedLanguages.find(
    (lang) => lang.value === languageValue,
  );
  if (languageToRemove?.isDefault) return;
  setSelectedLanguages(
    selectedLanguages.filter((lang) => lang.value !== languageValue),
  );
};
